// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__13WQk","title":"InfoRow_title__1t3_C"};